module.exports = __webpack_public_path__ + "static/img/bg.ba5aebb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/events/bg.png
// module id = CELE
// module chunks = 12